<template>
    <div>
        <div class="row" v-if="$hasType('candidate')">

            <div v-if="mustShowSurveyPopup" class="col-lg-12">
                <b-alert variant="warning" show dismissible>
                    {{ uLang('app.dismissible_alert') }}! <b-link @click="onDismissibleClick">{{ uLang('app.open_customer_survey_popup') }}</b-link>
                </b-alert>
            </div>
            
            <div class="col-lg-6">
                <latest-traject
                    :trajectoryData="dashboardData.candidate.latest_started_traject"
                    :loading="loading"
                >
                </latest-traject>
            </div>

            <div class="col-lg-6 mt-lg-0 mt-4">
                <user-info />
            </div>

            <div
                v-if="$can('view-action-document-checks') && dashboardData.candidate"
                class="col-lg-12 mt-4"
            >
                <inspectable-action-documents-client-or-candidate
                    :action-document-checks="
            dashboardData.candidate.inspectable_action_documents
          "
                    :loading="loading"
                />
            </div>

            <div class="col-lg-12 mt-4">
                <user-tabs :relation="user">
                    <template slot="trajectory-enrolments">
                        <all-trajects
                            v-if="$hasType('candidate')"
                            :trajectoryData="dashboardData.candidate.all_trajects"
                            :loading="loading"
                            class="mt-4"
                        />
                    </template>
                </user-tabs>
            </div>

            <!-- Modals -->
            <coach-feedback-modal :openModalOuter="openModalOuter" @update:show="updateModalVisible"></coach-feedback-modal>
        </div>
        <div class="row" v-if="$hasType('coach')">
            <div class="col-lg-12">
                <customer-following-system
                    :trajectoryData="
            dashboardData.trajectory_manager.customer_follow_system
          "
                    :loading="loading"
                    @getTrajectories="getNewTrajectories($event)"
                >
                </customer-following-system>
            </div>
        </div>
        <div class="row mt-4" v-if="$hasRole('trajectory_inspector')">
            <div
                class="col-lg-12"
                v-if="$can('view-action-document-checks')"
            >
                <inspectable-action-documents></inspectable-action-documents>
            </div>

            <div class="col-lg-12 mt-4" v-if="$can('view-action-document-checks')">
                <open-action-documents></open-action-documents>
            </div>
        </div>
        <div class="row mt-4" v-if="$hasRole('contact') || $hasRole('casemanager')">
            <div
                v-if="$can('view-action-document-checks') && contactOrCasemanagerChecks"
                class="col-lg-12 mb-4"
            >
                <inspectable-action-documents-client-or-candidate
                    :action-document-checks="contactOrCasemanagerChecks"
                    :loading="loading"
                ></inspectable-action-documents-client-or-candidate>
            </div>
            <div class="col-lg-12" v-if="$can('download-action-progress')">
                <generated-reports></generated-reports>
            </div>
        </div>
        <div class="row mt-4" v-if="$hasRole('trajectory_administrator') || $hasRole('super_admin')">

            <div class="col-lg-12" v-if="$hasRole('trajectory_administrator') && $can('view-sales-invoices')">
                <failed-invoices></failed-invoices>
            </div>
            <div
                class="col-lg-12 mt-4"
                v-if="$hasRole('trajectory_administrator') && $can('enrol-candidates-in-trajectories')"
            >
                <assignable-trajectories></assignable-trajectories>
            </div>
            <div
                class="col-lg-12 mt-4"
                v-if="($hasRole('trajectory_administrator') && $can('enrol-candidates-in-trajectories')) || $hasRole('super_admin')"
            >
                <overview-open-trajectories></overview-open-trajectories>
            </div>
        </div>
    </div>
</template>
<script>
import {
    LatestTraject,
    AllTrajects,
} from "~/components/cards/dashboard/candidate";
import {
    FirstUpcomingActionDocument,
    UpcomingActionDocuments,
    CustomerFollowingSystem,
} from "~/components/cards/dashboard/coach";
import {
    InspectableActionDocuments,
    InspectableActionDocumentsClientOrCandidate,
    OpenActionDocuments,
} from "~/components/cards/dashboard/trajectory-inspector";
import { GeneratedReports } from "~/components/cards/dashboard/client";
import { UserInfo } from "~/components/cards/dashboard";
import {
    AssignableTrajectories,
    OverviewOpenTrajectories,
    FailedInvoices,
} from "~/components/cards/dashboard/trajectory-administrator";
import { LogsTable } from "~/components/tables";
import { mapGetters } from "vuex";
import { LogsTab, UserTabs } from "~/components/tabs";
import CoachFeedbackModal from "~/components/modals/coach-feedback-modal";

export default {
    name: "dashboard",
    components: {
        LogsTab,
        FirstUpcomingActionDocument,
        UpcomingActionDocuments,
        LatestTraject,
        AllTrajects,
        UserInfo,
        CustomerFollowingSystem,
        InspectableActionDocuments,
        InspectableActionDocumentsClientOrCandidate,
        OpenActionDocuments,
        GeneratedReports,
        AssignableTrajectories,
        OverviewOpenTrajectories,
        FailedInvoices,
        LogsTable,
        CoachFeedbackModal,
        UserTabs,
    },

    data() {
        return {
            loading: true,
            dashboardData: {
                candidate: {
                    all_traject: [],
                    inspectable_action_documents: [],
                    latest_started_traject: [],
                },
            },
            parameters: {},
            mustShowSurveyPopup: false,
            openModalOuter: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "authUser",
        }),
        contactOrCasemanagerChecks() {
            const contact = this.dashboardData.contact;
            const casemanager = this.dashboardData.casemanager;

            if (contact && contact.inspectable_action_documents) {
                return contact.inspectable_action_documents;
            }
            if (casemanager && casemanager.inspectable_action_documents) {
                return casemanager.inspectable_action_documents;
            }
            return null;
        },
    },
    async created() {
        this.dashboardData = {
            candidate: {
                latest_started_traject: {},
                all_trajects: [],
                inspectable_action_documents: [],
            },
            trajectory_manager: {
                first_upcoming_action_document: {},
                upcoming_action_documents: [],
                customer_follow_system: [],
            },
            trajectory_inspector: {
                inspectable_action_documents: [],
                open_action_documents: [],
            },
            client: {
                generated_reports: [],
            },
            trajectory_administrator: {
                assignable_trajectories: [],
                overview_open_trajectories: [],
                failed_invoices: [],
            },
        };
        if (!($hasType("id_employee"))) {
            this.setParameters();
            const { data } = await window.axios.get(route("dashboard.index"), {
                params: this.parameters,
            });
            this.loading = false;
            this.dashboardData = data;
        }
    },
    mounted() {
        if($hasType('candidate'))
        {
            window.axios.get(route('relation.feedback.showmodal')).then(({data}) => {
                this.openModalOuter = data.showModal;
                this.mustShowSurveyPopup = data.showModal;

                const surveyDismissed = localStorage.getItem("surveyDismissed");
                if (surveyDismissed) {
                    this.openModalOuter = false;
                }
                localStorage.setItem("surveyDismissed", true);
            });
        }
    },
    methods: {
        onDismissibleClick() {
            this.openModalOuter = true;
        },
        updateModalVisible(value) {
            this.openModalOuter = value;
        },
        async getNewTrajectories(withStatusses) {
            if (withStatusses.length === 0) {
                return;
            }
            this.loading = true;

            const { data } = await window.axios.get(route("dashboard.index"), {
                params: {
                    statusses: withStatusses,
                },
            });

            this.loading = false;
            this.dashboardData = data;
        },

        setParameters() {
            this.parameters = {};

            if ($hasType("coach")) {
                this.parameters.statusses = ["started"];
            }
        },
    },
};
</script>
<style scoped></style>
